import React, { useState, useEffect } from "react";
import { Modal } from "@beleef/ui";
import Button from "components/ui/Button";
import { useUpdateRegistrySearchUsageMutation } from "apis/registrySearch";
import { formatDateTime } from "utils/helperFunctions";
import { formatType } from "utils/registrySearch";

const DetailRow = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-xs uppercase tracking-wide text-darkgray">{label}</span>
    <span className="text-darkergray break-words">{String(value ?? "-")}</span>
  </div>
);

const EditEntryModal = ({ entry, organizationId, isOpen, onClose }) => {
  const { mutate, isPending } = useUpdateRegistrySearchUsageMutation();
  const [form, setForm] = useState({ paid: false, cost: "", acn: "" });

  useEffect(() => {
    if (entry) {
      setForm({
        paid: entry.paid ?? false,
        cost: entry.cost ?? "",
        acn: entry.acn ?? "",
      });
    }
  }, [entry]);

  if (!entry) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = { id: entry._id, organizationId, paid: form.paid };
    if (form.cost !== "" && form.cost !== null) body.cost = Number(form.cost);
    if (form.acn !== "") body.acn = form.acn;
    mutate(body, { onSuccess: onClose });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Usage Record" className="max-w-md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 gap-3 text-sm mb-2">
          <DetailRow label="Type" value={formatType(entry.type)} />
          <DetailRow label="Date" value={formatDateTime(entry.createdAt)} />
          <DetailRow label="Property" value={entry.property?.address || entry.property?._id || "-"} />
          <DetailRow
            label="User"
            value={
              entry.user?.name
                ? `${entry.user.name}${entry.user.email ? ` (${entry.user.email})` : ""}`
                : "-"
            }
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-darkergray mb-1">Cost ($)</label>
          <input
            className="form-input border border-mediumgray w-full"
            type="number"
            step="0.01"
            min="0"
            value={form.cost}
            onChange={(e) => setForm((p) => ({ ...p, cost: e.target.value }))}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-darkergray mb-1">ACN</label>
          <input
            className="form-input border border-mediumgray w-full"
            type="text"
            placeholder="e.g. 008676417"
            value={form.acn}
            onChange={(e) => setForm((p) => ({ ...p, acn: e.target.value }))}
          />
        </div>

        <div className="flex items-center gap-2">
          <input
            id="paid-check"
            type="checkbox"
            checked={form.paid}
            onChange={(e) => setForm((p) => ({ ...p, paid: e.target.checked }))}
            className="h-4 w-4 cursor-pointer"
          />
          <label htmlFor="paid-check" className="text-sm font-medium text-darkergray cursor-pointer">
            Mark as Paid
          </label>
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <Button type="button" className="gray-button" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" className="black-button" disabled={isPending}>
            {isPending ? "Saving…" : "Save"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default EditEntryModal;
